import { useEffect, useState } from "react";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import { BLOGS_API } from "../../../../../Utilities/APIs/APIs";
import Image from "../../../../Partials/Elements/Image/Image";

function ViewBlog({ targetID }) {
  const axiosInstance = useAxiosInstance();
  const [blogInfo, setBlogInfo] = useState(null);

  useEffect(() => {
    async function fetchAndSetSingleBlog() {
      const { data } = await axiosInstance.get(BLOGS_API + targetID);
      setBlogInfo(data);
    }

    fetchAndSetSingleBlog();
  }, [targetID, axiosInstance]);

  return (
    <div className="crud_view_content">
      {blogInfo && (
        <>
          <h1>Title</h1>
          <p>{blogInfo.title}</p>

          <h1>Slug</h1>
          <p>{blogInfo.slug}</p>

          <h1>Category</h1>
          <p>{blogInfo.category}</p>

          <h1>Quotation</h1>
          <p>{blogInfo.excerpt}</p>

          <h1>Visibility</h1>
          <p>{blogInfo.isVisible === true ? "True" : "False"}</p>

          <h1>Precedence</h1>
          <p>{blogInfo.precedence}</p>

          <h1>Section One Title</h1>
          <p>{blogInfo.sectionOneTitle}</p>

          <h1>Section One Text</h1>
          <p dangerouslySetInnerHTML={{ __html: blogInfo.sectionOneText }} />

          <h1>Section Two Title</h1>
          <p>{blogInfo.sectionTwoTitle}</p>

          <h1>Section Two Text</h1>
          <p dangerouslySetInnerHTML={{ __html: blogInfo.sectionTwoText }} />

          <h1>Main Image</h1>
          <Image imgLink={blogInfo.image} imgAlt={blogInfo.title} />

          <h1>Second Image</h1>
          {blogInfo.secondImage ? (
            <Image imgLink={blogInfo.secondImage} imgAlt={blogInfo.title} />
          ) : (
            <p>No second image</p>
          )}
        </>
      )}
    </div>
  );
}

export default ViewBlog;